/* @jsx h */
import { defineComponent, h } from "vue";
import { useLocalization } from "@lemmonhq/uikit";

export interface ErrorStateProps {
  error: string;
  onRetry?: () => void;
}

export const ErrorState = defineComponent<ErrorStateProps>({
  name: "ErrorState",
  props: ["error", "onRetry"],
  setup(props) {
    const { t } = useLocalization();
    return () => (
      <div class="flex items-center justify-center min-h-screen">
        <div class=" bg-base-200 rounded shadow-xl max-w-md w-full mx-4">
          <div class="p-3 lg:p-4">
            <div class="text-6xl mb-4">⚠️</div>
            <h2 class="card-title justify-center text-error mb-2">
              {t("customer.checkout_status.something_went_wrong")}
            </h2>
            <p class="text-base-content/70 mb-4">
              {props.error || t("customer.checkout_status.unexpected_error")}
            </p>
            {props.onRetry && (
              <div class="card-actions justify-center">
                <button class="btn btn-primary" onClick={props.onRetry}>
                  <span class="material-symbols-outlined mr-2">refresh</span>
                  {t("customer.checkout_status.try_again")}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  },
});
